import { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { Queries } from 'apollo';
import useAuthContext from 'hooks/useAuthContext';
import { isAfter } from 'date-fns';

const useGetMyNotifications = () => {
  const context = useAuthContext();
  const [notifications, setNotifications] = useState([]);
  const [userSettings, setSettings] = useState({});
  const [fetchTimestamp, setTimestamp] = useState(Date.now());
  const { data, loading, refetch } = useQuery(Queries.GetMyNotifications, {
    fetchPolicy: 'no-cache',
    pollInterval: 600000,
    context,
  });

  useEffect(() => {
    if (data && data.getCurrentUser) {
      // set the fetch timestamp, so when it gets set, 
      // the window of notifications that will be 
      // wrongly marked as read, is as small as possible
      setTimestamp(Date.now())
      
      let settings = JSON.parse(data.getCurrentUser.settings);
      setSettings(settings);
      
      let timestamp = settings.lastReadNotifications
        ? new Date(settings.lastReadNotifications)
        // New account with no settings yet
        // force all notifications to unread state on first time
        // when the tray closes, it will record a new timestamp 
        // which will invalidate this second case
        : new Date('January 01, 2000 12:00:00');
      // Prepare the data so it can have the internal flag of read/unread basing it
      // on the user's lastReadTimestamp
      let userNotifications = (data.getCurrentUser.userNotifications || []).map(
        n => {
          const startAt = new Date(parseInt(n.startAt, 10));
          const unread = isAfter(startAt, timestamp);
          const notificationSettings = { ...JSON.parse(n.settings), unread };
          return {
            ...n,
            settings: notificationSettings,
          };
        },
      );
      setNotifications(userNotifications);
    }
  }, [data]);

  return [{ notifications, userSettings, timestamp: fetchTimestamp }, loading, refetch];
};

export default useGetMyNotifications;
